import { render, staticRenderFns } from "./ShortenName.vue?vue&type=template&id=5a6ca275&"
import script from "./ShortenName.vue?vue&type=script&lang=ts&"
export * from "./ShortenName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports